const C = {
  name: "Japan",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 8C13 8.55 12.55 9 12 9C11.45 9 11 8.55 11 8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8Z" fill="currentColor"/>
<path d="M18 10C18 10.55 17.55 11 17 11C16.45 11 16 10.55 16 10C16 9.45 16.45 9 17 9C17.55 9 18 9.45 18 10Z" fill="currentColor"/>
<path d="M7 11C7.55 11 8 10.55 8 10C8 9.45 7.55 9 7 9C6.45 9 6 9.45 6 10C6 10.55 6.45 11 7 11Z" fill="currentColor"/>
<path d="M12 2C6.47772 2 2 6.47772 2 12V12.5352L6.4547 15.505L6.45312 15.5073L8.11723 16.6167L8.1188 16.6144L10.1987 18.001L7.68018 19.68L9.12018 21.12L11.9987 19.201L12 19.2019L12.0015 19.2009L14.8802 21.12L16.3202 19.68L13.8102 18L13.8065 17.9975L15.881 16.6145L15.8825 16.6167L17.5466 15.5073L17.5451 15.5051L22 12.5352V12C22 6.47772 17.5223 2 12 2ZM19.9831 11.4761L16.3659 13.8876C15.2702 12.7233 13.7174 12 11.9999 12C10.2824 12 8.72966 12.7232 7.634 13.8875L4.01689 11.4761C4.2868 7.3025 7.75831 4 12 4C16.2417 4 19.7132 7.3025 19.9831 11.4761ZM14.6664 15.0206L12 16.7982L9.33349 15.0205C10.0433 14.3833 10.9782 14 11.9999 14C13.0216 14 13.9566 14.3833 14.6664 15.0206Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Japan
};
